var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.isLoading
      ? {}
      : {
          backgroundImage: `url('${_vm.src}')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }),attrs:{"data-testid":_vm.testId},on:{"click":_vm.emitClickEvent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }